export default function Complaints() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Complaints
            </div>
            <div className="page-sub" id="page-sub">
              Raise and track complaints
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="card">
            <div className="card-title">Complaints</div>
            <p className="muted" style={{ fontSize: 13 }}>
              This module is fully available in the complete build.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
